import SetAcceptanceRequestModelBase from '../_generated/modelBases/set-acceptance-request-model-base';

export default class SetAcceptanceRequestModel extends SetAcceptanceRequestModelBase {
  // For instructions on how to use Models visit:
  // https://glittrsoftware.visualstudio.com/glittr.core/_wiki/wikis/glittr.core.wiki/429/ServiceModels-DTOs
}
